export default __webpack_public_path__ + "static/media/criollita.513accbf.jpg";